/**
 * @generated SignedSource<<618a49bb53cd5b008ecbf6ea4fcff399>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptModalContent_note$data = {
  readonly __typename: "Note";
  readonly id: string;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_note">;
  readonly " $fragmentType": "TranscriptModalContent_note";
};
export type TranscriptModalContent_note$key = {
  readonly " $data"?: TranscriptModalContent_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModalContent_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModalContent_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "7153f83c3c8d8819ea8cf4a6102c0e52";

export default node;
